import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { ButtonModule } from 'primeng/button'
import { ErrorTypeEnum } from './enum/error.enum'

@Component({
    selector: 'app-error',
    imports: [CommonModule, ButtonModule],
    templateUrl: './error.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Error {
    messageType = input<string>()

    ErrorTypeEnum = ErrorTypeEnum

    logout = output<void>()
}
